module.exports = __webpack_public_path__ + "img/o.d7a2111d.svg";